// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.card-languages[data-v-4c2226b8] {\r\n  position: absolute;\r\n  z-index: 100;\r\n  top: 30px;\r\n  right: 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
